/**
 * Privacy-enhanced (youtube-nocookie.com) embed URL for a YouTube video id.
 * Autoplays, since the player only mounts after the user asked to watch.
 *
 * @param {string} youtubeVideoId
 * @returns {string}
 */
export function youtubeEmbedUrl(youtubeVideoId) {
  const params = new URLSearchParams({ autoplay: '1', rel: '0', modestbranding: '1' });
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeVideoId)}?${params.toString()}`;
}
